import React from 'react';
import { ThemeProvider } from '@veneer/core';
import { QueryClient, QueryClientProvider } from 'react-query';
import Routes from './Routes';
import GlobalStyle from './assets/styles/global';
import './assets/styles/fonts.css';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Routes />
        <GlobalStyle />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
